import { render, staticRenderFns } from "./LegoCardPayload.vue?vue&type=template&id=1530a213&scoped=true&"
import script from "./LegoCardPayload.vue?vue&type=script&lang=ts&"
export * from "./LegoCardPayload.vue?vue&type=script&lang=ts&"
import style0 from "./LegoCardPayload.vue?vue&type=style&index=0&id=1530a213&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1530a213",
  null
  
)

export default component.exports